import './WhatLeadershipNetIsSection.scss'

const WhatLeadershipNetIsSection = () => (
  <section className="lnn-section lnn-whatIsSection">
    <div className="lnn-shell lnn-whatIsSection__layout" data-reveal="up">
      <div className="lnn-sectionHead">
        <h2>What leadership.NET Is</h2>
      </div>

      <div className="lnn-whatIsSection__content">
        <p>leadership.NET is focused on one thing:</p>
        <p>how leadership intent moves through an organization and becomes action</p>
        <p className="lnn-whatIsSection__literal">The name is literal.</p>
        <p>Leadership does not operate in isolation.</p>
        <p>It operates across a network of people interpreting and acting on direction.</p>
        <p>That network determines whether a decision holds—or breaks.</p>
      </div>
    </div>
  </section>
)

export default WhatLeadershipNetIsSection
